import axios from "axios";

export async function updateCount() {
    return await axios.post(
      "https://k0cubzhx62.execute-api.us-east-1.amazonaws.com/default/visitorCounter"
    );
  }